import React from 'react';

const formatLabel = (val) => {
  if (!val) return '—';
  return val.replace(/_/g, ' ');
};

const SitesPanel = ({
  sites,
  jobs,
  trees,
  selectedSiteId,
  onSelectSite,
  onCreateSite,
  onEditSite,
  onCreateJobForSite,
  onOpenJob,
}) => {
  const selectedSite = sites.find((s) => s.site_id === selectedSiteId);
  const siteJobs = selectedSite
    ? jobs.filter((j) => j.site_id === selectedSite.site_id)
    : [];

  return (
    <div>
      <button
        type="button"
        className="btn btn-primary btn-touch"
        style={{ width: '100%', marginBottom: 16 }}
        onClick={onCreateSite}
      >
        + Create site
      </button>

      {sites.length === 0 && (
        <div className="empty-state">
          <p>No sites yet</p>
          <p style={{ fontSize: 12, marginTop: 8 }}>Create a site, then add a job to start surveying trees.</p>
        </div>
      )}

      {sites.map((site) => {
        const jobCount = jobs.filter((j) => j.site_id === site.site_id).length;
        const isSelected = selectedSiteId === site.site_id;
        return (
          <div
            key={site.site_id}
            className={`job-list-item job-list-item-touch ${isSelected ? 'selected' : ''}`}
            onClick={() => onSelectSite?.(site)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && onSelectSite?.(site)}
          >
            <div className="site-list-row">
              <div className="list-item-headline">
                <h4>{site.name}</h4>
                <span className="list-item-meta">
                  {jobCount} {jobCount === 1 ? 'job' : 'jobs'}
                  {site.site_conditions ? ` · ${formatLabel(site.site_conditions)}` : ''}
                </span>
              </div>
              {isSelected && (
                <button
                  type="button"
                  className="btn btn-secondary btn-sm btn-edit btn-touch-inline"
                  onClick={(e) => {
                    e.stopPropagation();
                    onEditSite?.(site);
                  }}
                >
                  Edit
                </button>
              )}
            </div>
            {site.gps_lat != null && site.gps_lng != null && (
              <span className="coords-hint">
                {Number(site.gps_lat).toFixed(5)}, {Number(site.gps_lng).toFixed(5)}
              </span>
            )}
          </div>
        );
      })}

      {selectedSite && (
        <div className="site-detail panel-section">
          <h3>Survey trees at {selectedSite.name}</h3>
          <p className="empty-inline site-detail-hint">
            Trees are added inside a <strong>job</strong>. Create a job, open it, then tap <strong>+ Tree</strong> or long-press the map.
          </p>

          <button
            type="button"
            className="btn btn-primary btn-touch"
            style={{ width: '100%', marginBottom: 12 }}
            onClick={() => onCreateJobForSite?.(selectedSite)}
          >
            + Create job
          </button>

          {siteJobs.length === 0 ? (
            <p className="empty-inline">No jobs for this site yet.</p>
          ) : (
            <>
              <p className="empty-inline" style={{ marginBottom: 8, fontSize: 12 }}>
                Open a job to add trees and groups:
              </p>
              {siteJobs.map((job) => {
                const treeCount = trees.filter((t) => t.job_id === job.job_id).length;
                return (
                  <div
                    key={job.job_id}
                    className="job-list-item job-list-item-touch"
                    onClick={() => onOpenJob?.(job)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => e.key === 'Enter' && onOpenJob?.(job)}
                  >
                    <div className="list-item-headline">
                      <h4>{job.name}</h4>
                      <span className="list-item-meta">
                        {formatLabel(job.status)} · {treeCount} {treeCount === 1 ? 'tree' : 'trees'}
                      </span>
                    </div>
                  </div>
                );
              })}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default SitesPanel;
